import {
  BROWSE_TYPE_EMPLOYERS,
  BROWSE_TYPE_PLACES,
  BROWSE_TYPE_VACANCIES,
} from 'pages/bladeren';
import { useState } from 'react';
import usePagination from './usePagination';
import useDidMountEffect from './useDidMountEffect';

export function getFetchItemsPath({ type, letter, page }) {
  switch (type) {
    case BROWSE_TYPE_EMPLOYERS:
      return `/browse/employers?letter=${letter}&page=${page}`;
    case BROWSE_TYPE_VACANCIES:
      return `/browse/vacancies?letter=${letter}&page=${page}`;
    case BROWSE_TYPE_PLACES:
      return `/browse/places?letter=${letter}&page=${page}`;
    default:
      return '';
  }
}

export default function useBrowseTypeAndLetter({
  type,
  letter,
  initItems = [],
  initTotalResults = 0,
  scrollToRef,
  limit,
}) {
  const [items, setItems] = useState(initItems);
  const [totalResults, setTotalResults] = useState(initTotalResults);
  const [loading, setLoading] = useState(false);

  const fetchItems = async ({ page }) => {
    setLoading(true);
    await fetch(`/api${getFetchItemsPath({ type, letter, page })}`)
      .then(res => res.json())
      .then(data => {
        if (type === BROWSE_TYPE_PLACES) {
          setItems(data.aggregations.places.buckets);
          setTotalResults(data.aggregations.places_count.value);
        } else {
          setItems(data.results);
          setTotalResults(data.totalResults);
        }
      })
      .finally(() => setLoading(false));
  };

  const {
    currentPage,
    totalPages,
    hasNextPage,
    hasPrevPage,
    handleNextPage,
    handlePrevPage,
    handleGoToPage,
    resetPagination,
  } = usePagination({
    total: totalResults,
    limit,
    fetchMore: fetchItems,
    scrollToRef,
  });

  useDidMountEffect(() => {
    resetPagination();
    fetchItems({ page: 1 });
  }, [type, letter]);

  return {
    items,
    totalResults,
    loading,
    currentPage,
    totalPages,
    hasNextPage,
    hasPrevPage,
    handleNextPage,
    handlePrevPage,
    handleGoToPage,
    resetPagination,
  };
}
